import { render, staticRenderFns } from "./QuestionnairesTable.vue?vue&type=template&id=8922359e&scoped=true"
import script from "./QuestionnairesTable.vue?vue&type=script&lang=js"
export * from "./QuestionnairesTable.vue?vue&type=script&lang=js"
import style0 from "./QuestionnairesTable.vue?vue&type=style&index=0&id=8922359e&prod&scoped=true&lang=scss"
import style1 from "./QuestionnairesTable.vue?vue&type=style&index=1&id=8922359e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8922359e",
  null
  
)

export default component.exports